import * as yup from "yup";

export const ASSOCIATE_STEWARD_INITIAL_VALUES = {
  selectedDataSource: "",
  stewardType: "",
  steward: "",
};

export const ASSOCIATE_STEWARD_VALIDATION_SCHEMA = yup.object({
  stewardType: yup.object().required("Steward Type is a required field"),
  steward: yup.object().required("Steward is a required field"),
});
